import React from 'react';
import searchIcon from './BigStatusIcon-search.svg';
import CircledCheck from '../CircledCheck';
export default function BigStatusIcon(_a) {
    var iconName = _a.iconName;
    if (iconName === 'BigStatusIcon-search')
        return React.createElement("img", { src: searchIcon, alt: "search prompt icon" });
    if (iconName === 'BigStatusIcon-check')
        return React.createElement(CircledCheck, { color: "#1170FF", secondaryColor: "#CCE0FF", size: 120 });
    return null;
}
